document.addEventListener('DOMContentLoaded', function() {
    const alltabHeader = document.querySelectorAll('.rtab-header');
    alltabHeader.forEach(tabHeader => {
        tabHeader.addEventListener('click', (e) => {
            e.preventDefault();
            const thisTab = tabHeader.getAttribute('data-tab');
            const thisParent = tabHeader.parentNode;
            const thisTabWrapper = thisParent.parentNode;
            const allTabs = thisParent.querySelectorAll('.rtab-header');
            const allTabContent = thisTabWrapper.querySelectorAll('.rtab-content');
            allTabs.forEach(siblingTabs => {
                siblingTabs.classList.remove('active');
            });
            tabHeader.classList.add('active');
            allTabContent.forEach(tabContent => {
                tabContent.classList.remove('active');
            });
            thisTabWrapper.querySelector(`.rtab-content[data-tab="${thisTab}"]`).classList.add('active');
        });
    });
});